module.exports = __webpack_public_path__ + "static/img/4.6620c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-contrastistas-proveedores/4.png
// module id = zD4k
// module chunks = 0